import './helpers/postDate';
import burgerMenu from './modules/header.js';
import twenty from './modules/twenty.js';
import slider from './modules/slider.js';
import fly from './modules/fly.js';
import impact from './modules/impact.js';
import nouislider from './modules/nouislider.js';


function main() {
  burgerMenu();
  twenty();
  slider();
  fly();
  impact();
  nouislider()
}
main()
